export default function InfoImage({ text }: { text: string }) {
  return (
    <div className="mx-auto flex h-60 w-60 items-center justify-center rounded-full border-[1rem] border-white bg-primary-bg shadow-info-circle">
      <p className="p-5 text-center text-lg font-semibold text-white">{text}</p>
    </div>
  );
}
